<template>
    <div class="main-wrapper">
        <div class="main-tab">
            <el-breadcrumb separator=">" class="customBreadcrumb">
                <el-breadcrumb-item>考试数据</el-breadcrumb-item>
                <el-breadcrumb-item>查看学生数据</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right">
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
        </div>
        <el-table :data="studentList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="1%"
                  :header-cell-style="{fontWeight: 'normal', height: '60px', color: '#666666', background: '#F6F6F6',fontSize: '16px'}"
                  :cell-style="{fontSize: '16px',color: '#333333',height: '70px'}">
            <el-table-column prop="nickname" label="学生名称"></el-table-column>
            <el-table-column prop="theory_score" label="理论题得分" align="center">
                <template slot-scope="scope">
                    <span>{{Math.floor(scope.row.theory_score )}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="practical_score" label="操作题得分" align="center">
                <template slot-scope="scope">
                    <span>{{Math.floor(scope.row.practical_score)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="合计得分" align="center">
                <template slot-scope="scope">
                    <span>{{(Math.floor(scope.row.theory_score) + Math.floor(scope.row.practical_score))}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false">
                        <router-link class="a-link"
                                     :to="{path: '/examManage/examData/theory', query: {id: scope.row.user_id, examId: scope.row.exam_id }}">
                            查看详情
                        </router-link>
                    </el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pages-center" style="margin: 20px 0"
                       :current-page="listPages.currentPageNum"
                       :page-size="listPages.eachPageNum"
                       layout="prev, pager, next, jumper"
                       :total="listPages.total"
                       @current-change="pageCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
    import {examination_student_score} from '@/utils/apis'

    export default {
        data() {
            return {
                examId: this.$route.query.examId || null,
                studentList: [],
                listPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                teacherToken: localStorage.getItem('teacherToken') || '',
            }
        },
        mounted() {
            this.getList();
        },
        methods: {
            // 获取列表
            getList() {
                let params = {
                    examination_id: this.examId,
                    page: this.listPages.currentPageNum,
                    limit: this.listPages.eachPageNum
                }
                examination_student_score(params).then((res) => {
                    this.studentList = res.data.list;
                    this.listPages.total = res.data.total;
                }).catch((err) => {
                    console.log('err', err)
                })
            },
            // 切换页面
            pageCurrentChange(val) {
                this.listPages.currentPageNum = val
                this.getList()
            },
            goBack() {
                this.$router.push('/examManage/examData')
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
    }

    .main-tab {
        font-size: 16px;
        line-height: 1;
        border-bottom: 1px solid #F1F5FF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 39px;
        position: relative;

        .right {
            position: absolute;
            top: -10px;
            right: 0;
        }
    }

    .a-link {
        color: inherit;
    }
</style>